export default "__VITE_ASSET__4fc59edc__"